import script from "./CustomerDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDetailModal.vue?vue&type=style&index=0&id=6b2a61c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2a61c1"]])

export default __exports__